import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClientService } from './api-client.service';
import type { CreateCloserDocumentPayload, PortfolioScoutResponse } from '../models/sales-closer.models';

@Injectable({
  providedIn: 'root',
})
export class SalesCloserService {
  private readonly apiClient = inject(ApiClientService);

  scoutPortfolio(file: File): Observable<PortfolioScoutResponse> {
    const formData = new FormData();
    formData.append('income_approach', file, file.name);
    return this.apiClient.postFormData<PortfolioScoutResponse>('/sales/portfolio-scout', formData);
  }

  createCloserDocument(payload: CreateCloserDocumentPayload): Observable<Blob> {
    const formData = new FormData();
    formData.append('client_name', payload.clientName);
    formData.append('rep_name', payload.repName);
    formData.append('rep_title', payload.repTitle);
    formData.append('rep_email', payload.repEmail);
    formData.append('document_type', payload.documentType);
    formData.append('income_approach', payload.file, payload.file.name);
    formData.append('fee_pct', String(payload.feePct));
    if (payload.methods) {
      formData.append('methods', JSON.stringify(payload.methods));
    }
    return this.apiClient.postFormDataForBlob('/sales/closer-document', formData);
  }
}
